export default __webpack_public_path__ + "static/media/Search.bc8f27cd.svg";